import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import cfg, {
  msgDirectionClientToUser,
  msgDirectionSystemToUser,
  UPDATE_CHAT_ACTIVE,
  UPDATE_CHAT_REMINDER_REMOVE
} from "../../../constants";
import {i_star} from "../../../icons";
import {chatAddFavoriteAction, chatRemoveFavoriteAction} from "../../../actions/chatAction";

export function ChatListItem({item}) {

  const dispatch = useDispatch();
  const [classes, setClasses] = useState('');

  const clientID = useSelector(state => state.chat.clientID);

  const handleFavorite = (e) => {
    e.stopPropagation();
    if (!item.is_favorites) {
      dispatch(chatAddFavoriteAction(item.id, item.chat_id));
    } else {
      dispatch(chatRemoveFavoriteAction(item.id, item.chat_id));
    }
  };

  const handleSelect = () => {
    if (clientID !== item.id) {
      dispatch({
        type: UPDATE_CHAT_ACTIVE,
        chat: item
      });
    }
  };

  useEffect(() => {
    const cls = [];
    if (item.channel_active === false) {
      cls.push('messages__item--disabled');
    }
    if (clientID === item.id) {
      cls.push('messages__item--active');
    } else {
      // Необработанное обращение в поддержку выделяется так же, как непрочитанное
      // сообщение: техспециалист по списку и выбирает, кем заняться. Снимается
      // оно кнопкой «вопрос решён», а не открытием переписки — прочитать и не
      // ответить не значит разобраться
      if (item.new_support) {
        cls.push('messages__item--bold');
      }
      if (item.last_messages && item.last_messages.id &&
        (item.last_messages.message_direction === msgDirectionClientToUser || item.last_messages.message_direction === msgDirectionSystemToUser) &&
        item.last_messages.read_status === false) {
        cls.push('messages__item--bold');
      }
    }
    setClasses(cls.length > 0 ? ' ' + cls.join(' ') : '');
  }, [clientID, item]);

  return <div className={"messages__item " + classes} onClick={handleSelect}>
    <div className="messages__top">
      <div className="messages__author">
        <div className="messages__ava">
          {item.photo && <img src={cfg.public_url + 'auth/file/' + item.id + '/i/' + item.photo} alt="" />}
          {!item.photo && <div className="messages__ava--none">{item.first_name.substring(0, 1)}{item.last_name.substring(0, 1)}</div>}
        </div>
        <div className="messages__name">{item.first_name} {item.last_name}</div>
      </div>
      <span className={"messages__favorite" + (item.is_favorites ? " messages__favorite--active" : "")} onClick={handleFavorite}>
        {i_star(14, item.is_favorites)}
      </span>
      <DateString date={item.last_messages && item.last_messages.id ? item.last_messages.created : item.created}
                                                isUnread={!!item.new_support || (item.last_messages && item.last_messages.id && (item.last_messages.message_direction === msgDirectionClientToUser || item.last_messages.message_direction === msgDirectionSystemToUser) && item.last_messages.read_status === false)}/>

    </div>
    <p className="messages__paragraph">{item.last_messages && item.last_messages.id ? item.last_messages.message : ''}</p>
  </div>;
}

export function ChatReminderItem({item}) {

  const dispatch = useDispatch();
  const clientID = useSelector(state => state.chat.clientID);
  const handleSelect = () => {
    if (clientID !== item.id) {
      dispatch({
        type: UPDATE_CHAT_ACTIVE,
        chat: item
      });
    }
    dispatch({type: UPDATE_CHAT_REMINDER_REMOVE, chat_id: item.chat_id});
  };

  return <div className="messages__item messages__item--continue" onClick={handleSelect}>
    <div className="messages__top">
      <div className="messages__author">
        <div className="messages__ava">
          {item.photo && <img src={cfg.public_url + 'auth/file/' + item.id + '/i/' + item.photo} alt="" />}
          {!item.photo && <div className="messages__ava--none">{item.first_name.substring(0, 1)}{item.last_name.substring(0, 1)}</div>}
        </div>
        <div className="messages__name">{item.first_name} {item.last_name}</div>
      </div>
      <span className="messages__data"></span>
    </div>
    <p className="messages__paragraph">Необходимо продолжить общение</p>
  </div>;
}

function DateString({date, isUnread}) {
  const [dateFormatted, setDateFormatted] = useState({
    short: '',
    date: '',
    time: ''
  });

  useEffect(() => {
    const dt = new Date(date.replace('Z', ''));
    const now = new Date();
    const utc1 = Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate());
    const utc2 = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    const diff = Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));

    setDateFormatted({
      short: diff === 0 ? 'Сегодня' : (diff === 1 ? 'Вчера' : diff + ' дн'),
      date: ('0' + dt.getDate()).slice(-2) + '.' + ('0' + (dt.getMonth() + 1)).slice(-2) + '.' + ('' + dt.getFullYear()).slice(-2),
      time: ('0' + dt.getHours()).slice(-2) + ':' + ('0' + dt.getMinutes()).slice(-2)
    })
  }, [date]);

  return <span className={"messages__data tooltip" + (isUnread ? " messages__data--active" : "")}>{dateFormatted.short} <span
    className="tooltip__text tooltip__text--right"> <span>{dateFormatted.date}</span> в <span>{dateFormatted.time}</span></span></span>;
}
